import styled from 'styled-components';

export const VictoryContainer = styled.div`
  height: 100%;
  width: 100%;
  /* position: absolute; */
  /* overflow: hidden; */
  background-image: url(${props => props.image});
  /* z-index: 99; */
  align-self: center;
  left: 0;
  right: 0;
  margin: auto;
  margin-top: 100px;
  bottom: 0;
  top: 0;
  @media(max-width: 900px){
    width: 95%;
  }
`;

export const VictoryTextDiv = styled.div`
  color: white;
  font-size: 72px;
  font-family: 'Staatliches';
  max-width: 860px;
  margin: 0.5em auto;
`;

export const VictoryTimeDiv = styled.div`
  color: #EB8A26;
  font-size: 120px;
  font-family: 'Staatliches';
  max-width: 450px;
  margin: 20px auto 10px auto;
  background-color: white;
  padding: 50px;
  border-radius: 8px;
`;

export const LogoStyle = styled.img`
  width: 250px;
  height: auto;
  margin: 50px 0 25px 0;
`;

export const SocialContainerText = styled.p`
  font-size: 18px;
  line-height: 1.6;
`;

export const SocialContainer = styled.div`
  background-color: white;
  padding: 50px;
  max-width: 450px;
  margin: 20px auto 10px auto;
  font-family: 'Raleway';
  font-weight: bold;
  border-radius: 8px;
`;

export const SocialFlex = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 20px auto;
`;

export const VictoryTitle = styled.h4`
  font-size: 24px;
  line-height: 1.2;
  color: white;
  white-space: pre-wrap;
  font-family: 'Raleway';
  text-align: center;
`